import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const PASSWORD_PLACEHOLDER = "3b-password-placeholder";

export const loginCredentials = defineConnector({
  identifier: "loginCredentials",
  name: "Login credentials",
  tagLine: "Username and password authentication",
  logo,
  protocol: "http",
  tags: ["custom"],
  defaultUrlPattern: () => ".*",
  customizeStepHandledInline: true,
  auth: customAuth("loginCredentials", {
    placeholder: PASSWORD_PLACEHOLDER,
  }),
  steps: [
    {
      title: "Configure your login credentials",
      items: [
        {
          kind: "input",
          label: "Name",
          placeholder: "My login credentials",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "url-pattern",
          placeholder: "api.example.com",
          target: { kind: "connectedApp", field: "urlPattern" },
        },
        {
          kind: "input",
          label: "Username",
          placeholder: "user@example.com",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          placeholder: "••••••••",
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "url",
          label: "Test URL (optional)",
          placeholder: "https://api.example.com/user",
          helperText:
            "URL to test the connection. Leave blank to skip testing.",
          target: { kind: "configuration", field: "testUrl" },
        },
      ],
    },
  ],
  connectionTest: { protocol: "http", request: ({ testUrl }) => `${testUrl}` },
  publicEnvVars: ({ username }) => ({
    LOGIN_USERNAME: username ?? "",
    LOGIN_PASSWORD: PASSWORD_PLACEHOLDER,
  }),
});
